/**
 * Copiar un reporte maestro (opcionalmente con responsables).
 */
import React, { useState, useEffect } from 'react';
import { studio, Field } from './studioUi';

const ReportCopyModal = ({ show, onClose, report, onConfirm, styles }) => {
    const [newReportName, setNewReportName] = useState('');
    const [copyResponsibles, setCopyResponsibles] = useState(true);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (report) {
            setNewReportName(`${report.reporteNombre} - Copia`);
            setCopyResponsibles(true); // Default to true
        }
    }, [report]);

    const handleConfirmClick = async () => {
        if (!newReportName.trim()) {
            alert('El nombre del reporte no puede estar vacío.');
            return;
        }
        setLoading(true);
        try {
            await onConfirm(report.id, { newReportName, copyResponsibles });
            onClose(); // Close modal on success
        } catch (error) {
            // The parent component (AdminPanel) will show the alert.
            // We just need to stop the loading indicator.
        } finally {
            setLoading(false);
        }
    };

    if (!show || !report) {
        return null;
    }

    return (
        <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
                <h3 style={{ color: '#5E35B1', marginBottom: '20px', marginTop: 0 }}>Copiar Reporte: {report.reporteNombre}</h3>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <Field label="Nuevo nombre del reporte">
                        <input
                            id="newReportName"
                            type="text"
                            value={newReportName}
                            onChange={(e) => setNewReportName(e.target.value)}
                            style={studio.control}
                            placeholder="Nombre para la copia"
                        />
                    </Field>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <input
                            type="checkbox"
                            id="copyResponsibles"
                            checked={copyResponsibles}
                            onChange={(e) => setCopyResponsibles(e.target.checked)}
                            style={{ transform: 'scale(1.2)', cursor: 'pointer' }}
                        />
                        <label htmlFor="copyResponsibles" style={{ cursor: 'pointer' }}>
                            Copiar responsables y notificarles
                        </label>
                    </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '30px' }}>
                    <button onClick={onClose} style={styles.btnGray} disabled={loading}>
                        Cancelar
                    </button>
                    <button onClick={handleConfirmClick} style={styles.btnBlue} disabled={loading}>
                        {loading ? 'Copiando...' : 'Confirmar Copia'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReportCopyModal;